// extracted by mini-css-extract-plugin
export default {"Benefits__List":"benefits_Benefits__List__s-5c+","Benefits__Item":"benefits_Benefits__Item__oyurN","Item__Text":"benefits_Item__Text__-Ojr9"};